export enum MonthRecurrenceType {
    DAY = "day",
    FIRST_WEEKDAY_OCCURRENCE = "first",
    SECOND_WEEKDAY_OCCURRENCE = "second",
    THIRD_WEEKDAY_OCCURRENCE = "third",
    FOURTH_WEEKDAY_OCCURRENCE = "fourth",
    LAST_WEEKDAY_OCCURRENCE = "last",
}

export enum QuarterMonth {
    FIRST = "first",
    SECOND = "second",
    THIRD = "third",
}

export enum RecurrenceLeadUnit {
    DAYS = "days",
    WEEKS = "weeks",
    MONTHS = "months",
}

export enum RelativeCalendarPeriod {
    MONTH = "month",
    QUARTER = "quarter",
    YEAR = "year",
}

export enum RelativeCalendarPosition {
    SAME = "same",
    NEXT = "next",
}

export enum RelativeDayType {
    DAY = "day",
    FIRST = "first",
    LAST = "last",
}

export enum WorkStartDateMode {
    OFFSET_DAYS_AFTER_SERVICE_END = "offset_days_after_service_end",
    NEXT_WEEKDAY_AFTER_SERVICE_END = "next_weekday_after_service_end",
    RELATIVE_CALENDAR_DATE_AFTER_SERVICE_END = "relative_calendar_date_after_service_end",
}

export enum WorkEndDateMode {
    OFFSET_DAYS_AFTER_WORK_START = "offset_days_after_work_start",
    RELATIVE_CALENDAR_DATE_AFTER_WORK_START = "relative_calendar_date_after_work_start",
}

export enum ServiceTemplateRecurrenceStatus {
    ACTIVE = "active",
    PAUSED = "paused",
}
